/**
 * Handwritten Zod complement to validate.generated.ts.
 *
 * Concrete schemas (BridgeError, WorkoutSummary, SwimFirehoseResponse, etc.)
 * are codegen'd from shared/contract/types.ts into validate.generated.ts.
 * Generic helpers can't be expressed there because TypeScript generics
 * disappear from the runtime; they live here.
 *
 * Callers should import from this file (which re-exports everything in the
 * generated file too) so the split is invisible at call sites.
 */
import { z } from "zod";
import { BridgeResponseErrorSchema } from "./validate.generated";

export * from "./validate.generated";

export const BridgeResponseOkSchema = <T extends z.ZodTypeAny>(data: T) =>
  z.object({
    v: z.literal(1),
    ok: z.literal(true),
    id: z.string(),
    data,
  });

export const BridgeResponseSchema = <T extends z.ZodTypeAny>(data: T) =>
  z.union([BridgeResponseOkSchema(data), BridgeResponseErrorSchema]);
